import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { makeApiRequests } from '../../helpers/api';
import Loader from '../common/Loader';

const getLocalResponse = endpoint => {
  const localChoices = localStorage.getItem(endpoint);
  if (localChoices) {
    try {
      return JSON.parse(localChoices);
    } catch (e) {}
  }
  return null;
};
const CachedResponse = ({ dontCache = false, render, listEndpoint, forceFreshData, requestBody, responseModifier }) => {
  const [response, setResponse] = useState(null);
  const [responseLoading, setResponseLoading] = useState(true);

  const getResponse = () => {
    const localResponse = getLocalResponse(listEndpoint);
    if (!forceFreshData && localResponse) {
      setResponse(localResponse);
      setResponseLoading(false);
    }

    fetchRemoteResponse(forceFreshData || !localResponse);
  };

  const fetchRemoteResponse = async passResponseToParent => {
    let { response, error } = await makeApiRequests({ endpoint: `/${listEndpoint}/list`, requestBody });
    if (responseModifier) {
      response = responseModifier(response);
    }
    if (error) {
      toast.error(error);
      setResponseLoading(false);
      return;
    }

    if (passResponseToParent) {
      setResponse(response);
      setResponseLoading(false);
    }
    if (!dontCache) {
      localStorage.setItem(listEndpoint, JSON.stringify(response));
    }
  };

  useEffect(() => {
    getResponse();
  }, []);

  if (responseLoading) return <Loader />;

  return response ? render(response) : '';
};

export default CachedResponse;
